// Mirrors quickchat/guidelines.py; AiCommandsList.test.tsx asserts parity.
export const GUIDELINE_MAX_CHARS = 5000;
export const GUIDELINES_MAX_TOTAL_CHARS = 10000;
export const GUIDELINES_MAX_ITEMS = 250;
